module.exports = __webpack_public_path__ + "static/kiteSketchTwo-e31abfc5436708ffcf182309463684dd.png";